import React, { useEffect } from 'react';
import ManufaturingBanner from './ManufaturingBanner';
import GeospatialBanner from './GeospatialBanner';
import Scrollautoplaycards from './Scrollautoplaycards';


import Digitalcapabilityhovercards from './Digitalcapabilityhovercards';
import Ditalcards from './Ditalcards';
import DigitalmobilityTabscards from './DigitalmobilityTabscards';
import Geospatialanimatedcards from './Geospatialanimatedcards';

// All the data not founded in this code actually its reflected



const GeospatialPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <GeospatialBanner />

      {/* <CommunicationBanner /> */}
      {/* <BannersAero/> */}

      <Ditalcards />
      <Digitalcapabilityhovercards />
      <DigitalmobilityTabscards />
      {/* <Scrollautoplaycards /> */}
      <Geospatialanimatedcards  />

      <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style>
    </div>
  )
}

export default GeospatialPage;